import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  languages = [
    {
      name: 'ENGLISH',
      lang: 'en'
    },
    {
      name: 'FRENCH',
      lang: 'fr'
    },
    {
      name: 'SPANISH',
      lang: 'es'
    },
    {
      name: 'PORTUGUESE',
      lang: 'pt'
    }
  ];

  constructor(private translate: TranslateService) {
    this.translate.setDefaultLang('en');
    this.translate.use(sessionStorage.getItem('language'));
  }

  setLang(lang: string) {
    if (lang) {
      this.translate.use(lang);
      sessionStorage.setItem('language', lang);
    }
  }

  getLang(): string {
    return sessionStorage.getItem('language') || this.translate.getDefaultLang();
  }
}
